/**
 * 跨标签页 Auth 重置协同模块
 *
 * 当某个标签页执行登出或 token 被清除时，通过 BroadcastChannel 通知所有同源标签页
 * 同步清理各自的 Pinia store，避免旧 token 被写回 localStorage 导致乒乓循环。
 *
 * BroadcastChannel 消息不会投递给发送方自身，天然避免无限递归。
 */

const CHANNEL_NAME = "pino-auth-reset";

let channel: BroadcastChannel | null = null;

function getChannel(): BroadcastChannel {
  if (!channel) {
    channel = new BroadcastChannel(CHANNEL_NAME);
  }
  return channel;
}

/** 通知所有同源标签页同步清除 auth 状态 */
export function broadcastAuthReset(): void {
  try {
    getChannel().postMessage({ type: "auth-reset" });
  } catch {
    // BroadcastChannel 可能在某些环境不可用，静默忽略
  }
}

/**
 * 监听来自其他标签页的 auth-reset 通知
 * @returns 取消监听的 cleanup 函数
 */
export function onAuthReset(callback: () => void): () => void {
  try {
    const ch = getChannel();
    const handler = (event: MessageEvent) => {
      if (event.data?.type === "auth-reset") {
        callback();
      }
    };
    ch.addEventListener("message", handler);
    return () => ch.removeEventListener("message", handler);
  } catch {
    return () => {};
  }
}
